<template>
  <div class="GmzHqsjfx" v-loading = "loading">
    <div class="headerSearch">
      <div class="sousuo">
        <el-form
          ref="search"
          style="display: flex"
          :model="formInline"
          label-position="left"
          label-width="90px"
        >
          <el-form-item label="单位名称:">
            <el-input
              v-model="formInline.dwmc"
              placeholder="请输入"
            />
          </el-form-item>
          <el-form-item label="提醒时间:">
            <el-date-picker
              v-model="formInline.beginTime"
              style="width: 45%"
              type="datetime"
              value-format="yyyy-MM-dd HH:mm:ss"
              placeholder="选择"
            />
            -
            <el-date-picker
              v-model="formInline.endTime"
              style="width: 45%"
              type="datetime"
              value-format="yyyy-MM-dd HH:mm:ss"
              placeholder="选择"
            />
          </el-form-item>
          <div>
            <el-button
              type="primary"
              icon="el-icon-search"
              round
              size="small"
              @click="handleCurrentChange(1)"
            >搜索</el-button>
            <el-button
              icon="el-icon-refresh-left"
              style="width: 90px; height: 39px"
              round
              size="small"
              @click="resetDataSource"
            >重置</el-button>
          </div>
        </el-form>
      </div>
    </div>
    <div
      style="margin: auto;
        width: 95%;
        max-width: 1518px;
        background-color: white;
        padding-top: 40px;
        padding-bottom: 57px;"
    >
      <div class="tablemes">
        <div
          style="
            background-color: #f2f2f2;
            padding: 10px;
            border: 1px solid #f2f2f2;
          "
        >
          <el-button
            v-preventReClick
            icon="el-icon-upload2"
            size="mini"
            @click="dcexcel"
          >导出</el-button>
        </div>
        <el-table
          ref="dwzjgqtxTabel"
          :data="tableData"
          border
          :show-overflow-tooltip="true"
          :header-cell-style="{ background: '#F2F2F2' }"
          style="width: 100%"
        >
          <el-table-column
            prop="dwmc"
            label="单位名称"
          />
          <el-table-column
            prop="txlx"
            label="提醒类型"
          />
          <el-table-column
            prop="txnr"
            label="提醒内容"
          />
          <el-table-column
            prop="cjsj"
            label="生成时间"
          />
        </el-table>
        <el-pagination
          background
          layout="prev,pager,next,jumper,total,sizes"
          :total="total"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="pagesize"
          :current-page.sync="currentPage"
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { getTxjlList, exportTxjlList } from '@/assets/js/dwzjgqtx'
export default {
  name: 'GmzHqsjfx',
  data() {
    return {
      loading: false,
      formInline: { // 搜索表单
        dwmc: '',
        beginTime: '',
        endTime: ''

      },
      currentPage: 1, // 当前页
      pagesize: 10, // 每页的数据条数
      total: 0, // 列表总数
      tableData: [], // 表格数据
    }
  },
  mounted() {
    this.loadDatasource()
  },
  methods: {
    dcexcel() {
      this.$message.info('正在导出中...')
      exportTxjlList({
        param: this.formInline
      }).then((e) => {
        this.$message.success('导出成功!')
        const table = '单位证件过期提醒记录'
        const a = document.createElement('a')
        const blob = new Blob([e.data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8'
        })
        const objectUrl = URL.createObjectURL(blob)
        a.setAttribute('href', objectUrl)
        a.setAttribute('download', table + '.xlsx')
        a.click()
      })
    },
    // 当前页码改变时
    handleCurrentChange(val) {
      this.currentPage = val // 当前页
      this.loadDatasource()
    },
    // 查询列表数据
    loadDatasource() {
      getTxjlList({
        page: this.currentPage,
        size: this.pagesize,
        param: this.formInline
      }).then((e) => {
        this.tableData = e.data.data.rows
        this.total = e.data.data.total
      })
    },
    // 10条/页改变时
    handleSizeChange(val) {
      this.pagesize = val
      this.loadDatasource()
    },
    // 重置
    resetDataSource() {
      this.formInline = {
        gdwmc: '',
        beginTime: '',
        endTime: ''
      },
      this.loadDatasource()
    }
  }
}
</script>

<style scoped lang='less'>
  .GmzHqsjfx {
    .headerSearch {
      max-width: 1518px;
      width: 95%;
      margin: auto;
      margin-bottom: 11px;
      margin-top: 30px;
      background-color: white;
      padding: 30px 0 20px 0;
      // border: 1px solid red;
      display: flex;
      align-items: center;
      box-shadow: 0px 1px 27px 3px rgba(0, 0, 0, 0.05);
      border-radius: 5px;
      font-size: 15px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
      .sousuo {
        width: 90%;
        margin-left: auto;
        margin-right: auto;
        display: flex;
        justify-content: space-between;
      }
      .el-form-item {
        margin-bottom: 10px;
        margin-right: 30px;
      }
    }
    .tablemes {
      margin: auto;
      width: 90%;
      max-width: 1375px;
      // margin-top: 21px;
      // margin-bottom: 57px;
      // /deep/ .el-table__header {
      //   .el-checkbox {
      //     display: none !important;
      //   }
      // }
      .el-pagination__total {
        margin-left: 8px;
      }
      .el-pagination {
        padding: 10px 0;

        border: 1px solid #ebeef5;
        border-top: 0;
      }
      // .addButton {
      //   color: #fff;
      //   background: #4170ff;
      //   border-radius: 3px;
      //   border-color: #4170ff;
      // }
      .deleteButton {
        background: #ff5721 !important;
        border-color: #ff5721 !important;
      }
      .el-button--warning {
        color: #fff;
        background: #feb800;
        border-radius: 3px;
        border-color: #feb800;
      }
      .el-button--primary {
        color: #fff;
        background: #4170ff;
        border-radius: 3px;
        border-color: #4170ff;
      }
      .el-pager {
        .number {
          background: #4170ff;
          border-color: #4170ff;
        }
      }
    }
  }

  /deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #4170ff !important;
    color: #fff;
  }
  /deep/ .disableheadselection > .cell .el-checkbox__inner {
    display: none !important;
  }
</style>
